import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import {  Link } from "react-router-dom";
import { APILA } from "../../../../../../config/apila";
import swal from "sweetalert";
import { PulseLoader } from "react-spinners";
import { APIMS } from "../../../../../../config/apims";

/* ===========================
   CSS
=========================== */
const css = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 35px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 14px;
  //   outline:none;
  //   background: #fff;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }

  .at-panel{
    margin-top: 14px;
    background:#fff;
    border:1px solid #e7eaf0;
    overflow: hidden;
  }

  .at-table-wrap{ overflow:auto; }

  .at-table{
    width:100%;
    border-collapse: collapse;
  }

  .at-table thead th{
    text-align:left;
    font-size: 14px;
    color:#3f51b5;
    font-weight: 700;
    padding: 12px 14px;
    border-bottom:1px solid #e9edf5;
    white-space: nowrap;
    background: #fff;
  }

  .at-table tbody td{
    padding: 12px 14px;
    border-bottom:1px solid #edf1f7;
    font-size: 14px;
    color:#0f172a;
    vertical-align: middle;
  }

  .at-center { text-align: center !important; }

  .at-select{
    width:100%;
    height: 40px;
    border:1px solid #cfd8e6;
    border-radius: 0;
    padding: 0 10px;
    font-size: 14px;
    color: #334155;
    background: #fff;
    outline: none;
  }

  .at-select:disabled{
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }

  .at-select option[disabled]{
    color: #94a3b8;
  }
`;

export default function KonfigurasiPasscode() {
  document.title = "Konfigurasi Passcode";
  // const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  
    const [page] = useState(1);
    const [limit] = useState(1000);
    const [ascending] = useState(1);
    const [descending] = useState(0);
    const [keyword] = useState("");
    const token = localStorage.getItem("token");
    
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
    const [loading, setLoading] = useState(false);

    const firstLoadDone = useRef(false);

    const storageBranchGroping = localStorage.getItem("ysb_branch_id");
    const storageLevel = localStorage.getItem("level");
    const storageTeacher = localStorage.getItem('teacherID');
    const storageBranch = localStorage.getItem('ysb_branch_id');
    const storageSchoolId = localStorage.getItem('ysb_school_id');

    const id_user = localStorage.getItem("id_admin") || "";
    const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");
    
    // Data master
    const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
    
    
    // Table data
    const [getData, setGetData] = useState([]);

    // Search 
    const [searchKeyword, setSearchKeyword] = useState("");

    // Pagination 
    const [tablePage, setTablePage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // UI state
    const [hasSearched, setHasSearched] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isFilterDirty, setIsFilterDirty] = useState(false);
    const [selectedTab, setSelectedTab] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const [namaTA, setNamaTA] = useState("");
    const [namaSmstr, setNamaSmstr] = useState("");

    const [nisnSourceRows, setNisnSourceRows] = useState([]);
    const [isLoadingTambahNisn, setIsLoadingTambahNisn] = useState(false);

    const [isCustomPasscodeModalOpen, setIsCustomPasscodeModalOpen] = useState(false);
    const [customPasscode, setCustomPasscode] = useState("");

    const [customPasscodeTarget, setCustomPasscodeTarget] = useState({
      student: true,
      otm: false,
    });

    // const toggleCustomPasscodeModal = () => {
    //   setIsCustomPasscodeModalOpen((prev) => !prev);
    // };

    const toggleCustomPasscodeModal = () => {
      if (isSavingPasscode) return;

      setIsCustomPasscodeModalOpen((prev) => {
        const next = !prev;

        if (next) {
          setCustomPasscodeTarget({
            student: true,
            otm: false,
          });
        }

        return next;
      });
    };

    // Passcode & Save 
    const [isConfirmSaveOpen, setIsConfirmSaveOpen] = useState(false);
    const [isSavingPasscode, setIsSavingPasscode] = useState(false);

    // Undo auto passcode (cancel)
    const [beforeAutoPasscodeRows, setBeforeAutoPasscodeRows] = useState(null);
    const [showCancelAutoPasscode, setShowCancelAutoPasscode] = useState(false);

    //Button Save
    const [showSavePasscodeButton, setShowSavePasscodeButton] = useState(false);

    const toggleConfirmSave = () => {
      if (isSavingPasscode) return;
      setIsConfirmSaveOpen((prev) => !prev);
    };

    // Reset Modal 
    const [isResetModalOpen, setIsResetModalOpen] = useState(false);
    const [isResettingType, setIsResettingType] = useState(""); 

    const toggleResetModal = () => {
      if (isResettingType) return; 
      setIsResetModalOpen((prev) => !prev);
    };

   // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id:"",
    ysb_kelas_id:"",
  });

      
  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }), [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);
    
  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);
    
  const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const normalizeStudentName = (value) => {
      return safeStr(value)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
  };

  // const sanitizePasscodeValue = (value, maxLength = 12) => {
  //     return String(value || "").replace(/\D/g, "").slice(0, maxLength);
  // };

  const sanitizePasscodeValue = (value, maxLength = 12) => {
    return String(value || "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, maxLength);
  };

  // =========================
  // INIT: Semester
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // )
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        )
      ]);

      if (!isMounted.current) return;

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
      setLoading(false); 
    }

  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);
      
  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Filter complete
  // =========================
  const isFilterComplete = isFilterDirty && !!form2.ysb_semester_id 


    // =========================
    // Fetch table data
    // =========================
    const GetResponseData = useCallback(async () => {
      if (
        !form2.ysb_semester_id 
      ) return;

      setIsFetching(true);
      const params = {
        ysb_semester_id: form2?.ysb_semester_id,
        level: storageLevel,
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher
      };

      try {
        const response = await APILA.get(
          "/api/config-auth-students/index",
          {
          params,
          ...fetchParams,
          }
        );

      if (response?.status === 200) {
        setGetData(response.data.students || []);
        setBeforeAutoPasscodeRows(null);
        setShowCancelAutoPasscode(false);
        setShowSavePasscodeButton(false); 
      }
      } catch (error) {
        swal({
          title: "Gagal",
          text: error?.response?.data?.message || "Gagal mengambil data",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    }, [form2, fetchParams, storageLevel]);

  // FIRST LOAD
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id 
    ) return;
    
    firstLoadDone.current = true;
    
    (async () => {
      setIsFetching(true);
      await GetResponseData(); 
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
    
  }, [form2.ysb_semester_id]);

  // =========================
  // HANDLER perubahan filter 
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (!form2.ysb_semester_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setGetData([]);
    setSearchKeyword("");
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };


    // =========================
    // Filter + Search + Sorting 
    // =========================
    // const displayedData = useMemo(() => {
    //   let rows = Array.isArray(getData) ? [...getData] : [];
     
    //   // Search (Nama siswa / NISN)
    //   const q = safeStr(searchKeyword).trim().toLowerCase();
    //   if (q) {
    //     rows = rows.filter((r) => {
    //       const siswa = safeStr(r?.siswa).toLowerCase();
    //       const nisn = safeStr(r?.nisn).toLowerCase();
    //       const passcodeSiswa = safeStr(r?.ysb_passcode_student).toLowerCase();

    //       return (
    //         siswa.includes(q) ||
    //         nisn.includes(q) ||
    //         passcodeSiswa.includes(q)
    //       );
    //     });
    //   }
     
    //   // Sort nama siswa A -> Z
    //   rows.sort((a, b) => collator.compare(safeStr(a?.siswa), safeStr(b?.siswa)));
  
    //   return rows;
    // }, [collator, form2.ysb_grade_level_id, form2.ysb_kelas_id, getData, searchKeyword]);


const displayedData = useMemo(() => {
      let rows = Array.isArray(getData) ? [...getData] : [];

      // Search (Nama siswa / NISN)
      const q = safeStr(searchKeyword).trim().toLowerCase();
      if (q) {
        rows = rows.filter((r) => {
          const siswa = safeStr(r?.siswa).toLowerCase();
          const nisn = safeStr(r?.nisn).toLowerCase();
          const passcodeSiswa = safeStr(r?.ysb_passcode_student).toLowerCase();

          return (
            siswa.includes(q) ||
            nisn.includes(q) ||
            passcodeSiswa.includes(q)
          );
        });
      }

      // SORT:
      // siswa lama A-Z di atas, siswa baru order_absen di bawah
      rows.sort((a, b) => {
        const orderA =
          a?.order_absen === null ||
          a?.order_absen === undefined ||
          a?.order_absen === ""
            ? null
            : Number(a.order_absen);

        const orderB =
          b?.order_absen === null ||
          b?.order_absen === undefined ||
          b?.order_absen === ""
            ? null
            : Number(b.order_absen);

        const aIsNew = orderA !== null && !Number.isNaN(orderA);
        const bIsNew = orderB !== null && !Number.isNaN(orderB);

        if (!aIsNew && bIsNew) return -1;
        if (aIsNew && !bIsNew) return 1;

        if (aIsNew && bIsNew) {
          if (orderA !== orderB) return orderA - orderB;

          const nameCompare = collator.compare(
            safeStr(a?.siswa),
            safeStr(b?.siswa)
          );

          if (nameCompare !== 0) return nameCompare;

          return collator.compare(
            safeStr(a?.nisn),
            safeStr(b?.nisn)
          );
        }

        const nameCompare = collator.compare(
          safeStr(a?.siswa),
          safeStr(b?.siswa)
        );

        if (nameCompare !== 0) return nameCompare;

        return collator.compare(
          safeStr(a?.nisn),
          safeStr(b?.nisn)
        );
      });

      return rows;
    }, [collator, form2.ysb_grade_level_id, form2.ysb_kelas_id, getData, searchKeyword]);
  
    // =========================
    const toTitleCase = (value) => {
      const s = safeStr(value).toLowerCase().trim();
      if (!s) return "";
      return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
    };

    // =========================
    // PASSCODE HELPERS
    // =========================
    const generate4Digit = () => {
      return String(Math.floor(1000 + Math.random() * 9000));
    };

    const takeSnapshotBeforeAuto = () => {
      if (beforeAutoPasscodeRows && Array.isArray(beforeAutoPasscodeRows)) {
        setShowCancelAutoPasscode(true);
        return;
      }

      const snapshot = (getData || []).map((row) => ({ ...row }));
      setBeforeAutoPasscodeRows(snapshot);
      setShowCancelAutoPasscode(true);
    };

    const handleCancelAutoPasscode = () => {
      if (!beforeAutoPasscodeRows || !Array.isArray(beforeAutoPasscodeRows)) return;

      const restored = beforeAutoPasscodeRows.map((row) => ({ ...row }));
      setGetData(restored);

      setBeforeAutoPasscodeRows(null);
      setShowCancelAutoPasscode(false);
      setShowSavePasscodeButton(false);

    };

    const fetchKonfigurasiAngketForNisn = useCallback(async () => {
      const params = {
        ysb_branch_id: storageBranch || "",
        ysb_school_id: storageSchoolId || "",
        ysb_semester_id: form2.ysb_semester_id || "",
        "ysb_teacher_id": storageTeacher || "",
      };

      // if (form2.ysb_grade_level_id) {
      //   params.ysb_grade_level_id = form2.ysb_grade_level_id;
      // }

      // if (form2.ysb_kelas_id) {
      //   params.ysb_kelas_id = form2.ysb_kelas_id;
      // }

      const res = await APILA.get("/api/konfigurasi-angket-teacher", {
        params,
        ...fetchParams,
      });

      return res?.data?.data || [];
    }, [form2, fetchParams]);

    const handleAutoPasscodeSiswa = () => {
      if (!Array.isArray(getData) || getData.length === 0) {
        swal({
          title: "Info",
          text: "Data siswa belum tersedia.",
          icon: "info",
          timer: 1800,
          buttons: false,
        });
        return;
      }

      takeSnapshotBeforeAuto();

      const samePasscode = generate4Digit();

      const updated = getData.map((row) => ({
        ...row,
        ysb_passcode_student: samePasscode,
      }));

      setGetData(updated);
      setShowSavePasscodeButton(true);
    };

    const handleAutoPasscodeOTM = () => {
      if (!Array.isArray(getData) || getData.length === 0) {
        swal({
          title: "Info",
          text: "Data siswa belum tersedia.",
          icon: "info",
          timer: 1800,
          buttons: false,
        });
        return;
      }

      takeSnapshotBeforeAuto();

      const used = new Set();
      const updated = getData.map((row) => {
        let code = generate4Digit();
        let safety = 0;

        while (used.has(code) && safety < 50) {
          code = generate4Digit();
          safety++;
        }

        used.add(code);

        return {
          ...row,
          ysb_passcode_otm: code,
        };
      });

      setGetData(updated);
      setShowSavePasscodeButton(true);
    };

    // const handleCustomPasscode = () => {
    //   if (!Array.isArray(getData) || getData.length === 0) {
    //     swal({
    //       title: "Info",
    //       text: "Data siswa belum tersedia.",
    //       icon: "info",
    //       timer: 1800,
    //       buttons: false,
    //     });
    //     return;
    //   }

    //   if (!customPasscode || customPasscode.trim() === "") {
    //     swal({
    //       title: "Info",
    //       text: "Passcode wajib diisi.",
    //       icon: "warning",
    //       timer: 1800,
    //       buttons: false,
    //     });
    //     return;
    //   }

    //   takeSnapshotBeforeAuto();

    //   const updated = getData.map((row) => ({
    //     ...row,
    //     ysb_passcode_student: customPasscode,
    //     ysb_passcode_otm: customPasscode,
    //   }));

    //   setGetData(updated);
    //   setShowSavePasscodeButton(true);

    //   setIsCustomPasscodeModalOpen(false);

    //   // swal({
    //   //   title: "Berhasil",
    //   //   text: "Custom passcode berhasil diterapkan.",
    //   //   icon: "success",
    //   //   timer: 1800,
    //   //   buttons: false,
    //   // });
    // };

    const handleCustomPasscodeTargetChange = (field) => {
      setCustomPasscodeTarget((prev) => ({
        ...prev,
        [field]: !prev[field],
      }));
    };

    // const handleCustomPasscode = async () => {
    //   if (!Array.isArray(getData) || getData.length === 0) {
    //     swal({
    //       title: "Info",
    //       text: "Data siswa belum tersedia.",
    //       icon: "info",
    //       timer: 1800,
    //       buttons: false,
    //     });
    //     return;
    //   }

    //   if (!customPasscode || customPasscode.trim() === "") {
    //     swal({
    //       title: "Info",
    //       text: "Custom passcode wajib diisi.",
    //       icon: "warning",
    //       timer: 1800,
    //       buttons: false,
    //     });
    //     return;
    //   }

    //   try {
    //     setIsSavingPasscode(true);

    //     takeSnapshotBeforeAuto();

    //     const updatedRows = getData.map((row) => ({
    //       ...row,
    //       ysb_passcode_student: String(customPasscode).trim(),
    //       ysb_passcode_otm: String(customPasscode).trim(),
    //     }));

    //     setGetData(updatedRows);

    //     const payload = buildPasscodePayload(updatedRows);

    //     const res = await APILA.post(
    //       "/api/config-auth-students/store",
    //       payload,
    //       fetchParams
    //     );

    //     setIsCustomPasscodeModalOpen(false);
    //     setCustomPasscode("");
    //     setShowSavePasscodeButton(false);
    //     setShowCancelAutoPasscode(false);
    //     setBeforeAutoPasscodeRows(null);

    //     swal({
    //       title: "Berhasil",
    //       text: res?.data?.message || "Custom passcode berhasil disimpan ke database.",
    //       icon: "success",
    //       timer: 2200,
    //       buttons: false,
    //     });

    //     await GetResponseData();
    //   } catch (error) {
    //     swal({
    //       title: "Gagal Menyimpan",
    //       text:
    //         error?.response?.data?.message ||
    //         "Terjadi kesalahan saat menyimpan custom passcode.",
    //       icon: "error",
    //     });
    //   } finally {
    //     setIsSavingPasscode(false);
    //   }
    // };

    const handleCustomPasscode = async () => {
  if (!Array.isArray(getData) || getData.length === 0) {
    swal({
      title: "Info",
      text: "Data siswa belum tersedia.",
      icon: "info",
      timer: 1800,
      buttons: false,
    });
    return;
  }

  const trimmedPasscode = String(customPasscode || "").trim();

  if (!trimmedPasscode) {
    swal({
      title: "Info",
      text: "Custom passcode wajib diisi.",
      icon: "warning",
      timer: 1800,
      buttons: false,
    });
    return;
  }

  if (!customPasscodeTarget.student && !customPasscodeTarget.otm) {
    swal({
      title: "Info",
      text: "Pilih minimal satu tujuan passcode: Passcode Siswa atau Passcode OTM.",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
    return;
  }

  try {
    setIsSavingPasscode(true);

    takeSnapshotBeforeAuto();

    const updatedRows = getData.map((row) => ({
      ...row,
      ...(customPasscodeTarget.student
        ? { ysb_passcode_student: trimmedPasscode }
        : {}),
      ...(customPasscodeTarget.otm
        ? { ysb_passcode_otm: trimmedPasscode }
        : {}),
    }));

    setGetData(updatedRows);

    const payload = buildPasscodePayload(updatedRows);

    const res = await APILA.post(
      "/api/config-auth-students/store",
      payload,
      fetchParams
    );

    setIsCustomPasscodeModalOpen(false);
    setCustomPasscode("");
    setCustomPasscodeTarget({
      student: true,
      otm: false,
    });
    setShowSavePasscodeButton(false);
    setShowCancelAutoPasscode(false);
    setBeforeAutoPasscodeRows(null);

    swal({
      title: "Berhasil",
      text:
        res?.data?.message ||
        "Custom passcode berhasil disimpan ke database.",
      icon: "success",
      timer: 2200,
      buttons: false,
    });

    await GetResponseData();
  } catch (error) {
    swal({
      title: "Gagal Menyimpan",
      text:
        error?.response?.data?.message ||
        "Terjadi kesalahan saat menyimpan custom passcode.",
      icon: "error",
    });
  } finally {
    setIsSavingPasscode(false);
  }
};

    const handleTambahNisn = async () => {
      if (!Array.isArray(getData) || getData.length === 0) {
        swal({
          title: "Info",
          text: "Data siswa belum tersedia.",
          icon: "info",
          timer: 1800,
          buttons: false,
        });
        return;
      }

      try {
        setIsLoadingTambahNisn(true);
        takeSnapshotBeforeAuto();

        const apiRows = await fetchKonfigurasiAngketForNisn();
        setNisnSourceRows(apiRows);

        if (!Array.isArray(apiRows) || apiRows.length === 0) {
          swal({
            title: "Info",
            text: "Data NISN dari konfigurasi angket tidak ditemukan.",
            icon: "info",
          });
          return;
        }

        const nisnMap = new Map();

        apiRows.forEach((item) => {
          const normalizedName = normalizeStudentName(item?.nama_siswa);
          const nisn = sanitizePasscodeValue(item?.nisn, 12);

          if (normalizedName && nisn) {
            nisnMap.set(normalizedName, nisn);
          }
        });

        let totalMatched = 0;

        const updated = getData.map((row) => {
          const normalizedRowName = normalizeStudentName(row?.siswa);
          const nisn = nisnMap.get(normalizedRowName) || "";

          if (nisn) totalMatched += 1;

          return {
            ...row,
            ysb_passcode_student: nisn || row?.ysb_passcode_student || "",
            ysb_passcode_otm: nisn || row?.ysb_passcode_otm || "",
          };
        });

        setGetData(updated);
        setShowSavePasscodeButton(true);

        // swal({
        //   title: "Berhasil",
        //   text:
        //     totalMatched > 0
        //       ? `${totalMatched} data siswa berhasil diisi dengan NISN sesuai nama.`
        //       : "Tidak ada nama siswa yang cocok dengan data NISN.",
        //   icon: totalMatched > 0 ? "success" : "info",
        //   timer: 2200,
        //   buttons: false,
        // });
      } catch (error) {
        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal mengambil data NISN dari API konfigurasi angket.",
          icon: "error",
        });
      } finally {
        setIsLoadingTambahNisn(false);
      }
    };

    // =========================
    // PASSCODE MANUAL
    // =========================
    // const handlePasscodeChange = (rowKey, field, value) => {
    //   const sanitized = String(value || "").replace(/\D/g, "").slice(0, 4);

    //   takeSnapshotBeforeAuto();

    //   setGetData((prev) =>
    //     (prev || []).map((row, idx) => {
    //       const key = row?.ysb_student_id || row?.id || idx;
    //       if (key !== rowKey) return row;
    //       return {
    //         ...row,
    //         [field]: sanitized,
    //       };
    //     })
    //   );
    //   setShowSavePasscodeButton(true);

    // };
    // const handlePasscodeChange = (rowKey, field, value) => {
    //   const sanitized = sanitizePasscodeValue(value, 12);

    //   takeSnapshotBeforeAuto();

    //   setGetData((prev) =>
    //     (prev || []).map((row, idx) => {
    //       const key = row?.ysb_student_id || row?.id || idx;
    //       if (key !== rowKey) return row;
    //       return {
    //         ...row,
    //         [field]: sanitized,
    //       };
    //     })
    //   );

    //   setShowSavePasscodeButton(true);
    // };

    const handlePasscodeChange = (rowKey, field, value) => {
      const sanitized = sanitizePasscodeValue(value, 12);

      takeSnapshotBeforeAuto();

      setGetData((prev) =>
        (prev || []).map((row, idx) => {
          const key = row?.ysb_student_id || row?.id || idx;
          if (key !== rowKey) return row;
          return {
            ...row,
            [field]: sanitized,
          };
        })
      );

      setShowSavePasscodeButton(true);
    };

    // =========================
    // HANDLE KLIK
    // =========================
    const handleClickSimpan = () => {
      if (!Array.isArray(getData) || getData.length === 0) {
        swal({
          title: "Info",
          text: "Tidak ada data siswa untuk disimpan.",
          icon: "info",
        });
        return;
      }

      setIsConfirmSaveOpen(true);
    };


    const buildPasscodePayload = (rows) => {
      return {
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_semester_id: form2.ysb_semester_id || "",
        ysb_teacher_id: storageTeacher,
        students: (rows || []).map((row) => ({
          ysb_student_id: row?.ysb_student_id || row?.id || "",
          ysb_passcode_student: String(row?.ysb_passcode_student || ""),
          ysb_passcode_otm: String(row?.ysb_passcode_otm || ""),
        })),
        user_id: output_id_user || "",
      };
    };

    // =========================
    // SAVE PASSCODE
    // =========================
    const handleConfirmSavePasscode = async () => {
      try {
        setIsSavingPasscode(true);

        const payload = buildPasscodePayload(getData || []);

        const res = await APILA.post(
          "/api/config-auth-students/store",
          payload,
          fetchParams
        );

        setIsConfirmSaveOpen(false);

        swal({
          title: "Berhasil",
          text: res?.data?.message || "Passcode berhasil disimpan ke database.",
          icon: "success",
          timer: 2200,
          buttons: false,
        });

        await GetResponseData();
      } catch (error) {
        swal({
          title: "Gagal Menyimpan",
          text: error?.response?.data?.message || "Terjadi kesalahan saat menyimpan passcode.",
          icon: "error",
        });
      } finally {
        setIsSavingPasscode(false);
      }
    };


    // RESET PASSCODE
    const handleOpenResetModal = () => {
      if (!Array.isArray(getData) || getData.length === 0) {
        swal({
          title: "Info",
          text: "Data siswa belum tersedia.",
          icon: "info",
          timer: 1800,
          buttons: false,
        });
        return;
      }
      setIsResetModalOpen(true);
    };

    const handleResetAndSave = async (type) => {
      try {
        if (!Array.isArray(getData) || getData.length === 0) {
          swal({
            title: "Info",
            text: "Data siswa tidak tersedia.",
            icon: "info",
          });
          return;
        }

        setIsResettingType(type); 

        const updatedRows = (getData || []).map((row) => ({
          ...row,
          ...(type === "student" ? { ysb_passcode_student: "" } : {}),
          ...(type === "otm" ? { ysb_passcode_otm: "" } : {}),
        }));

        setGetData(updatedRows);

        const payload = buildPasscodePayload(updatedRows);

        const res = await APILA.post(
          "/api/config-auth-students/store",
          payload, fetchParams
         
        );

        setIsResetModalOpen(false);

        swal({
          title: "Berhasil",
          text:
            res?.data?.message ||
            (type === "student"
              ? "Passcode siswa berhasil direset dan disimpan."
              : "Passcode OTM berhasil direset dan disimpan."),
          icon: "success",
          timer: 2200,
          buttons: false,
        });

        await GetResponseData();
      } catch (error) {
        swal({
          title: "Gagal Reset",
          text:
            error?.response?.data?.message ||
            (type === "student"
              ? "Terjadi kesalahan saat reset passcode siswa."
              : "Terjadi kesalahan saat reset passcode OTM."),
          icon: "error",
        });
      } finally {
        setIsResettingType("");
      }
    };

    return (
      <div className="body">
        <style>{css}</style>

      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGear} />
                  </span>
                <h4 className="page-title-text">  Konfigurasi Passcode</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li className="custom-breadcrumb-item">
                  <Link style={{ textDecoration: "none" }} to="/konfigurasi-angket-teacher">
                      Konfigurasi Angket
                    </Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                   Konfigurasi Passcode
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGear} />
                </span>
                <h4 className="page-title-text">  Konfigurasi Passcode</h4>
              </div>
            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li className="custom-breadcrumb-item">
                  <Link style={{ textDecoration: "none" }} to="/konfigurasi-angket-teacher">
                      Konfigurasi Angket
                    </Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                   Konfigurasi Passcode
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

        <div className="body-content">

              {/* FILTER */}
                          {isTabletOrMobile ? (
                            <div className="title-page">
                              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                                <select
                                  className="mr-2"
                                  name="ysb_semester_id"
                                  value={form2.ysb_semester_id}
                                  onChange={handleChange}
                                  style={{
                                    border: "1px solid #d9defa",
                                    borderRadius: "12px",
                                    fontSize: "14px",
                                    padding: "10px 12px",
                                    background: "#fff",
                                  }}
                                >
                                  <option value="" hidden>
                                    {namaTA} (Semester {namaSmstr})
                                  </option>
                                  {getDataSemesterMap.map((user, index) => (
                                    <option key={index} value={user?.id}>
                                      {user?.name_year} (Semester {user?.semester})
                                    </option>
                                  ))}
                                </select>
                              </Row>
                              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                                <button
                                          onClick={handleCari}
                                          disabled={!isFilterComplete}
                                          className="btn"
                                          style={{
                                            fontSize: "13px",
                                           padding: "10px 16px",
                                            borderRadius: "12px",
                                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                                            color: "#fff",
                                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                                            
                                          }}
                                        >
                                          Cari
                                        </button>
                              </Row>
                            </div>
                          ) : (
                            <>
                              <div className="mb-3">
                                {loading ? (
                                  <>
                                    <div className="mb-3 d-flex">
                                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                                      <div className="shimmer shimmer-select mr-2" style={{width:60, borderRadius: "12px"}} />
                                    </div>
                                  </>
                                ) : (
                                    <div className="mb-3 mt-1">
                                      <div className="d-flex">
                                        <select
                                          className="mr-2"
                                          name="ysb_semester_id"
                                          value={form2.ysb_semester_id}
                                          onChange={handleChange}
                                           style={{
                                            border: "1px solid #d9defa",
                                            borderRadius: "12px",
                                            fontSize: "14px",
                                            padding: "10px 12px",
                                            background: "#fff",
                                          }}
                                        >
                                          <option value="" hidden>
                                            {namaTA} (Semester {namaSmstr})
                                          </option>
                                          {getDataSemesterMap.map((user, index) => (
                                            <option key={index} value={user?.id}>
                                              {user?.name_year} (Semester {user?.semester})
                                            </option>
                                          ))}
                                        </select>
            
                                        <button
                                          onClick={handleCari}
                                          disabled={!isFilterComplete}
                                          className="btn"
                                          style={{
                                            fontSize: "13px",
                                           padding: "10px 16px",
                                            borderRadius: "12px",
                                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                                            color: "#fff",
                                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                                            
                                          }}
                                        >
                                          Cari
                                        </button>
                                      </div>
                                    </div>
                                )
                              }
                              </div>
                              
                            </>           
                          )}

          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <PulseLoader color={"#3f5bea"} size={12} />
            </div>
          )}

          {hasSearched && !isFetching && (
                <>
                  {isTabletOrMobile ? (
                    <div className="title-page">
                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <input
                          className="at-input"
                          placeholder="Cari Siswa / NISN"
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                      </Row>

                      

                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <button className="btn btn-create" onClick={handleOpenResetModal}
                          style={{backgroundColor: "#dc2626"}}
                        >
                          Reset
                        </button>
                      </Row>

                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <button
                          className="btn btn-create"
                          onClick={handleTambahNisn}
                          disabled={isLoadingTambahNisn}
                          style={{
                            width: "100%",
                            backgroundColor: "#2563eb",
                            opacity: isLoadingTambahNisn ? 0.7 : 1,
                            cursor: isLoadingTambahNisn ? "not-allowed" : "pointer",
                          }}
                        >
                          {isLoadingTambahNisn ? "Memuat NISN..." : "Tambah Nisn"}
                        </button>
                      </Row>

                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <button
                          className="btn btn-create"
                          onClick={toggleCustomPasscodeModal}
                          style={{
                            width: "100%",
                            backgroundColor: "#47d6f0",
                            color: "#000"
                          }}
                        >
                          Custom Passcode Semua
                        </button>
                      </Row>
                      
                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <button 
                        className="btn btn-create" 
                        onClick={handleAutoPasscodeSiswa} 
                        style={{  width: "100%", backgroundColor:  "#ff9100" }}
                        >
                          Auto Passcode Siswa
                        </button>
                      </Row>

                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <button
                          className="btn btn-create"
                          onClick={handleAutoPasscodeOTM}
                          style={{ backgroundColor: "#5440c8", width: "100%" }}
                        >
                          Auto Passcode OTM
                        </button>
                      </Row>

                      {showSavePasscodeButton && (
                        <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                          <button
                            className="btn btn-create"
                            onClick={handleClickSimpan}
                            style={{
                              width: "100%",
                              display: "block",
                            }}
                          >
                            Simpan
                          </button>
                        </Row>
                      )}
                      
                      {showCancelAutoPasscode && (
                        <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                          <button
                            className="btn"
                            onClick={handleCancelAutoPasscode}
                            title="Batalkan auto passcode"
                            style={{
                                width: "100%",
                                display: "block",
                                border: "1px solid #f1b5b5",
                                backgroundColor: "#fff5f5",
                                fontSize: "13px"
                            }}
                            >
                             Batal
                          </button>
                        </Row>
                      )}
                      

                    </div>
                  ) : (
                  <>
                    <div className="mt-4">
                      <div className="at-search mb-3">
                        <input
                            className="at-input"
                            placeholder="Cari Siswa / NISN"
                            value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                      </div>
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-create mr-3"
                          onClick={handleTambahNisn}
                          disabled={isLoadingTambahNisn}
                          style={{
                            backgroundColor: "#2563eb",
                            minWidth: "120px",
                            opacity: isLoadingTambahNisn ? 0.7 : 1,
                            cursor: isLoadingTambahNisn ? "not-allowed" : "pointer",
                          }}
                        >
                          {isLoadingTambahNisn ? "Memuat NISN..." : "Tambah Nisn"}
                        </button>

                        <button
                          className="btn btn-create mr-3"
                          onClick={toggleCustomPasscodeModal}
                          style={{
                            backgroundColor: "#47d6f0",
                            minWidth: "150px",
                            color: "#000"
                          }}
                        >
                          Custom Passcode Semua
                        </button>

                        <button className="btn btn-create mr-3" 
                          style={{ backgroundColor: "#ff9100" }}
                          onClick={handleAutoPasscodeSiswa}
                        >
                            Auto Passcode Siswa
                        </button>

                        <button
                          className="btn btn-create"
                          onClick={handleAutoPasscodeOTM}
                          style={{ backgroundColor: "#5440c8" }}
                        >
                          Auto Passcode OTM
                        </button>

                        <button
                          className="btn btn-create ml-2"
                          onClick={handleOpenResetModal}
                          style={{ backgroundColor: "#dc2626" }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>

                     {showSavePasscodeButton && (
                        <div className="mt-2">
                          <button
                            className="btn btn-create"
                            onClick={handleClickSimpan}
                            style={{
                              width: "100%",
                              display: "block",
                              padding: "7px 5px",
                              fontSize: "14px",
                              marginTop: "16px"
                            }}
                          >
                            Simpan
                          </button>
                        </div>
                      )}

                      {showCancelAutoPasscode && (
                        <div className="mt-2">
                          <button
                            className="btn mr-2"
                            onClick={handleCancelAutoPasscode}
                            title="Batalkan auto passcode"
                            style={{
                              border: "1px solid #f1b5b5",
                              backgroundColor: "#fff5f5",
                              width: "100%",
                              display: "block",
                              padding: "6px 5px",
                              fontSize: "14px",
                              marginTop: "10px"
                            }}
                          >
                            Batal
                          </button>
                        </div>
                          
                      )}
                  </>
                  
                  )}
                
                  <Col xl="12" sm="12">
                    <div className="mt-1 body-table">
                      <div className="at-panel">
                        <div className="at-table-wrap">
                          <table className="table w-100 table-hover table-bordered" id="basic-datatable">
                          
                            <thead>
                              <tr>
                                <th style={{ width: 90 }} className="at-center">No</th>
                                <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nama Siswa</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Passcode Siswa</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center" >Passcode OTM</th>
                                {/* <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Status Passcode Siswa</th> */}
                              </tr>
                            </thead>

                            <tbody>
                              {displayedData.length === 0 ? (
                                        <tr>
                                          <td colSpan={5} className="text-center" style={{ padding: "18px 8px" }}>
                                            Data tidak ditemukan
                                          </td>
                                        </tr>
                                      ) : (
                                        displayedData.map((row, index) => (
                                          <tr key={row?.ysb_student_id || row?.id || index}>
                                            <td className="text-center" style={{ lineHeight: "2" }}>
                                              {index + 1}
                                            </td>
                                            <td style={{ lineHeight: "2" }}>{toTitleCase(row.siswa)}</td>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                // maxLength={4}
                                                maxLength={12}
                                                value={row?.ysb_passcode_student || ""}
                                                onChange={(e) =>
                                                  handlePasscodeChange(
                                                    row?.ysb_student_id || row?.id || index,
                                                    "ysb_passcode_student",
                                                    e.target.value
                                                  )
                                                }
                                                style={{
                                                  // width: "90px",
                                                  width: "130px",
                                                  textAlign: "center",
                                                  border: "1px solid #d6dbe6",
                                                  borderRadius: "6px",
                                                  padding: "4px 8px",
                                                  fontSize: "14px",
                                                }}
                                               
                                              />

                                              
                                            </td>

                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                // maxLength={4}
                                                maxLength={12}
                                                value={row?.ysb_passcode_otm || ""}
                                                onChange={(e) =>
                                                  handlePasscodeChange(
                                                    row?.ysb_student_id || row?.id || index,
                                                    "ysb_passcode_otm",
                                                    e.target.value
                                                  )
                                                }
                                                style={{
                                                  // width: "90px",
                                                  width: "130px",
                                                  textAlign: "center",
                                                  border: "1px solid #d6dbe6",
                                                  borderRadius: "6px",
                                                  padding: "4px 8px",
                                                  fontSize: "14px",
                                                }}
                                              />
                                            </td>

                                            {/* <td style={{ lineHeight: "2", textAlign: "center" }}>
                                              {String(row?.ysb_passcode_student || "").match(/^\d{4}$/) ? (
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    padding: "2px 10px",
                                                    borderRadius: "999px",
                                                    background: "#e8f7ee",
                                                    color: "#18864b",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  Siap
                                                </span>
                                              ) : (
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    padding: "2px 10px",
                                                    borderRadius: "999px",
                                                    background: "#fff3cd",
                                                    color: "#946200",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  Belum
                                                </span>
                                              )}
                                            </td> */}
                                          </tr>
                                        ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                  
                </>
              )}

              <Modal
                isOpen={isConfirmSaveOpen}
                toggle={toggleConfirmSave}
                centered
                backdrop="static"
                size="md"
              >
                <ModalHeader
                  toggle={!isSavingPasscode ? toggleConfirmSave : undefined}
                >
                  <span style={{ fontWeight: 600, fontSize: 18 }}>
                    <FontAwesomeIcon icon={faFloppyDisk} /> Konfirmasi Simpan Passcode
                  </span>
                </ModalHeader>

                <ModalBody style={{ padding: "20px 18px" }}>
                  <div
                    style={{
                      background: "#eff6ff",
                      border: "1px solid #bfdbfe",
                      borderRadius: 8,
                      padding: 14,
                      marginBottom: 12,
                      color: "#1e3a8a",
                      fontSize: 14,
                      lineHeight: 1.6,
                      marginTop: 20
                    }}
                  >
                    Konfigurasi passcode yang telah dibuat akan
                    <b> disimpan. </b>
                  </div>
                  <span style={{ fontSize: 14, marginLeft: 5}}>
                    Apakah Anda yakin ingin menyimpan perubahan ini?
                  </span>

                </ModalBody>

                <ModalFooter
                  style={{
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                
                  <Button
                    color="secondary"
                    onClick={toggleConfirmSave}
                    disabled={isSavingPasscode}
                    style={{ 
                      fontSize: 13,
                      cursor: "pointer",
                    }}       
                  >
                    Batal
                  </Button>
                
                  <Button
                    onClick={handleConfirmSavePasscode}
                    disabled={isSavingPasscode}
                    style={{ backgroundColor: "#3f5bea", color: "#fff", fontSize: 13, cursor: "pointer" }}
                  >
                    {isSavingPasscode ? "Menyimpan..." : "Ya, Simpan"}
                  </Button>
                
                </ModalFooter>

              </Modal>

              <Modal
                isOpen={isResetModalOpen}
                toggle={toggleResetModal}
                centered
                backdrop="static"
                size="md"
              >
                <ModalHeader
                  toggle={!isResettingType ? toggleResetModal : undefined}
                  
                >
                  <span style={{ color: "#dc2626", fontWeight: 600, fontSize: 18 }}>
                    ⚠ Reset Passcode
                  </span>
                </ModalHeader>

                <ModalBody style={{ padding: "20px 18px" }}>
                  <div
                    style={{
                      border: "1px solid #f3d7d6",
                      borderRadius: "12px",
                      padding: "14px",
                      background: "#fff8f8",
                      marginBottom: "14px",
                      marginTop: 20
                    }}
                  >
                    <div style={{ fontSize: "14px", color: "#7f1d1d", fontWeight: 700, marginBottom: 6 }}>
                      Pilih jenis passcode yang ingin direset
                    </div>
                    <div style={{ fontSize: "13px", color: "#64748b", lineHeight: 1.6 }}>
                      Jika di-reset, <b>seluruh data passcode yang dipilih akan dihapus</b> dari konfigurasi.
                    </div>
                  </div>

                  <div style={{ display: "grid", gap: "10px" }}>
                    <Button
                      onClick={() => handleResetAndSave("student")}
                      disabled={!!isResettingType}
                      style={{
                        background: "#ff9100",
                        border: "none",
                        borderRadius: "10px",
                        padding: "8px 10px",
                        fontWeight: 600,
                        fontSize: 14
                      }}
                    >
                      {isResettingType === "student" ? (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                          <PulseLoader color="#ffffff" size={6} />
                          Reset Passcode Siswa...
                        </span>
                      ) : (
                        "Reset Passcode Siswa"
                      )}
                    </Button>

                    <Button
                      onClick={() => handleResetAndSave("otm")}
                      disabled={!!isResettingType}
                      style={{
                        background: "#5440c8",
                        border: "none",
                        borderRadius: "10px",
                        padding: "8px 10px",
                        fontWeight: 600,
                        fontSize: 14
                      }}
                    >
                      {isResettingType === "otm" ? (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                          <PulseLoader color="#ffffff" size={6} />
                          Reset Passcode OTM...
                        </span>
                      ) : (
                        "Reset Passcode OTM"
                      )}
                    </Button>
                  </div>
                </ModalBody>

                <ModalFooter style={{ borderTop: "none", padding: "8px 18px 18px" }}>
                  <Button
                    color="light"
                    onClick={toggleResetModal}
                    disabled={!!isResettingType}
                    style={{
                      borderRadius: "8px",
                      minWidth: "80px",
                      border: "1px solid #dbe2ee",
                   
                      fontSize: 14
                    }}
                  >
                    Tutup
                  </Button>
                </ModalFooter>
              </Modal>

              {/* <Modal
                isOpen={isCustomPasscodeModalOpen}
                toggle={toggleCustomPasscodeModal}
                centered
              >
                <ModalHeader toggle={toggleCustomPasscodeModal}>
                  Custom Passcode
                </ModalHeader>

                <ModalBody>

                  <label
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                       marginTop: "18px",
                      marginBottom: "12px",
                      display: "block",
                    }}
                  >
                    Masukkan Passcode
                  </label>

                 
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Masukkan passcode"
                    value={customPasscode}
                    onChange={(e) => setCustomPasscode(e.target.value)}
                    style={{
                      borderRadius: "10px",
                      fontSize: "14px",
                    }}
                  />


                </ModalBody>

                <ModalFooter>
                  <Button
                   className="btn-modal-cancel"
                    color="secondary"
                    onClick={toggleCustomPasscodeModal}
                  >
                    Batal
                  </Button>
                  
                  <Button
                    className="btn-modal-create"
                    color="primary"
                    onClick={handleCustomPasscode}
                    disabled={isSavingPasscode}
                  >
                    {isSavingPasscode ? "Menyimpan..." : "Simpan"}
                  </Button>
                </ModalFooter>
              </Modal> */}

              <Modal
  isOpen={isCustomPasscodeModalOpen}
  toggle={toggleCustomPasscodeModal}
  centered
  backdrop="static"
>
  <ModalHeader toggle={!isSavingPasscode ? toggleCustomPasscodeModal : undefined}>
    Custom Passcode
  </ModalHeader>

  <ModalBody>
    <label
      style={{
        fontSize: "15px",
        fontWeight: 600,
        marginTop: "18px",
        marginBottom: "12px",
        display: "block",
      }}
    >
      Masukkan Passcode
    </label>

    <input
      type="text"
      className="form-control"
      placeholder="Masukkan passcode"
      value={customPasscode}
      onChange={(e) => setCustomPasscode(e.target.value)}
      disabled={isSavingPasscode}
      style={{
        borderRadius: "10px",
        fontSize: "14px",
      }}
    />

    <div
      style={{
        marginTop: "18px",
        padding: "14px",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        backgroundColor: "#f8fafc",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          fontWeight: 700,
          marginBottom: "10px",
          color: "#334155",
        }}
      >
        Pilih tujuan passcode
      </div>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px",
          fontSize: "14px",
          cursor: isSavingPasscode ? "not-allowed" : "pointer",
        }}
      >
        <input
          type="checkbox"
          checked={customPasscodeTarget.student}
          onChange={() => handleCustomPasscodeTargetChange("student")}
          disabled={isSavingPasscode}
          style={{
            width: "16px",
            height: "16px",
            cursor: isSavingPasscode ? "not-allowed" : "pointer",
          }}
        />
        <span>Isi ke Passcode Siswa</span>
      </label>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: 0,
          fontSize: "14px",
          cursor: isSavingPasscode ? "not-allowed" : "pointer",
        }}
      >
        <input
          type="checkbox"
          checked={customPasscodeTarget.otm}
          onChange={() => handleCustomPasscodeTargetChange("otm")}
          disabled={isSavingPasscode}
          style={{
            width: "16px",
            height: "16px",
            cursor: isSavingPasscode ? "not-allowed" : "pointer",
          }}
        />
        <span>Isi ke Passcode OTM</span>
      </label>
    </div>
  </ModalBody>

  <ModalFooter>
    <Button
      className="btn-modal-cancel"
      color="secondary"
      onClick={toggleCustomPasscodeModal}
      disabled={isSavingPasscode}
    >
      Batal
    </Button>

    <Button
      className="btn-modal-create"
      color="primary"
      onClick={handleCustomPasscode}
      disabled={isSavingPasscode}
    >
      {isSavingPasscode ? "Menyimpan..." : "Simpan"}
    </Button>
  </ModalFooter>
</Modal>
            
            </div>
      </div>
    );
}